import { createStore } from "vuex";
import auth from './auth.module';
import productTypes from './productTypes.module';
const store = createStore({
    modules: {
        auth,
        productTypes
    },
});
export default store;